GameView = require "views/base/game"
Prefix = require("lib/prefix")
{ DraggyView }  = require("views/components/draggy")

class DialView extends GameView
  template: require("./template")

  events:
    "iostap .btn-done": "endGame"

  serialize: ->
    d = super

    increment = parseFloat(d.dial.increment, 10) or 1
    min = parseFloat(d.dial.min, 10)
    max = parseFloat(d.dial.max, 10)
    min = 0 if _.isNaN(min)
    max = 10 if _.isNaN(max)    

    if min > max
      min = max

    d.notches = Math.round((max - min) / increment)

    d.labels  = _.nearest _.factors(d.notches).map((m) -> m), d.dial.labels

    d.labelValues = [0...d.labels].map (i) ->
      value = new Big(Math.round(i * d.notches / d.labels))
      value = value.mul(increment).add(min)
      value

    d

  beforeShow: ->
    @setEl @findOne(".dial"), "dial"
    @setEl @findOne(".dial-knob-input"), "knob-input"
    @setEl @findOne(".dial-knob-input-value"), "knob-input-value"
    @setEl @findOne(".dial-knob-answer"), "knob-answer"
    @setEl @findOne(".dial-knob-answer-value"), "knob-answer-value"
    @setEl @findOne(".dial-knob-value"), "knob-value"
    @setEl @findAll(".dial-notch"), "notches"
    @setEl @findAll(".dial-label"), "labels"

    @rotateElements(@getEl("notches"))
    @rotateElements(@getEl("labels"))

  onRefresh: ->
    @beforeShow()
    super

  show: ->
    super
    el = @findOne(".content-fit")

    @draggy = new DraggyView
      el: @getEl("dial")
      radius: @getEl("dial").offsetWidth / 2
      isParent: true

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop

    @enterGame()

  rotateElements: (elements) ->
    dir = if @options.config().direction is "rtl" then -1 else 1
    for el, i in elements
      @transform el,
        rotate: i / elements.length * 360 * dir

  onDrag: (draggy, isInitialDrag) ->
    @currentValue = @roundValue(draggy)
    @labelEl @getEl("knob-value"), @currentValue

    @transform @getEl("knob-input"),
      rotate: "#{draggy.t}rad"
      transition: if isInitialDrag then "all 300ms" else "none"

    @transform @getEl("knob-input-value"),
      x: "-50%"
      rotate: "#{-draggy.t}rad"
      transition: if isInitialDrag then "all 300ms" else "none"

  onDrop: (draggy, isReset) ->
    if not isReset
      draggy.reset({t: @roundPos(draggy)})
    else
      @currentValue = @roundValue(draggy)
      @labelEl @getEl("knob-value"), @currentValue

      @transform @getEl("knob-input"),
        rotate: "#{draggy.t}rad"
        transition: "all 300ms"

      @transform @getEl("knob-input-value"),
        x: "-50%"
        rotate: "#{-draggy.t}rad"
        transition: "all 300ms"

      if @currentValue?
        @setState("touched")

  roundValue: (draggy) ->
    {increment, min, max} = @options.data.dial
    value = Big(max - min)
      .mul(@roundPercent(draggy))
      .div(increment)
      .round()
      .mul(increment)
      .plus(min)

    if @options.config().direction is "rtl" then Big(max - value) else value

  roundPos: (draggy) ->
    (Math.PI * 2) * @roundPercent(draggy)

  roundPercent: (draggy) ->
    {increment, min, max} = @options.data.dial

    max     = Big(max).sub(min).div(increment).round().mul(increment).plus(min)
    percent = _.limit(draggy.t / (Math.PI * 2), 0, 1)
    steps   = Big(max).sub(min).div(increment).valueOf()

    Big(steps)
      .mul(percent)
      .round()
      .div(steps)


  labelEl: (el, value) ->
    {prefix, suffix, decimals} = @options.data.dial

    decimals = parseFloat(decimals, 10) or 0
    value = parseFloat(value, 10).toFixed(decimals) if decimals > 0
    el.innerHTML = "#{prefix}#{value}#{suffix}"

  showAnswer: ->
    @animateAnswerKnob()
    @draggy.lock()

  isCorrect: ->
    @currentValue? and
    @currentValue.eq @options.data.answer.value

  animateAnswerKnob: ->
    {answer, dial} = @options.data
    {increment, min, max} = dial
    max     = Big(max).sub(min).div(increment).round().mul(increment).plus(min)
    percent = (answer.value - min) / (max - min)
    percent = 1 - percent if @options.config().direction is "rtl"

    @transform @getEl("knob-answer"),
      rotate: "#{@draggy.t}rad"
      transition: "none"

    @transform @getEl("knob-answer-value"),
      x: "-50%"
      rotate: "-#{@draggy.t}rad"
      transition: "none"

    @getEl("knob-answer").offsetWidth

    @transform @getEl("knob-answer"),
      rotate: "#{percent * Math.PI * 2}rad"
      transition: if @draggy.locked then "none" else "all 600ms"

    @transform @getEl("knob-answer-value"),
      x: "-50%"
      rotate: "-#{percent * Math.PI * 2}rad"
      transition: if @draggy.locked then "none" else "all 600ms"

  endGame: ->
    super

    @submit()

  answerDetails: ->
    questions = @options.metadata?.questions or []
    return [] unless questions.length > 0
    question = questions[0]

    correct = @isCorrect()
    value = parseInt(@currentValue)

    answer = _.find question.answers, (a) -> a.correct is correct
    details = question: question.question, answer: answer

    details.answer.content = value

    [ details ]


module.exports = DialView
